/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface OnboardingSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const OnboardingComponent = templateOnlyComponent<OnboardingSignature>();

export default OnboardingComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    Onboarding: typeof OnboardingComponent;
    onboarding: typeof OnboardingComponent;
  }
}
